import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchReplaceCardChatHours = gql`
  query FetchReplaceCardChatHours {
    replaceCardChatHours {
      ... on ReplaceCardChatHoursSuccess {
        __typename
        id
        header
        subTitle
        chatHoursTitle
        supportTicketLink {
          title
          url
        }
        hours
        footer
        isChatEnabled
      }
      ... on ReplaceCardChatHoursError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default FetchReplaceCardChatHours;
